import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

function LoopVideoPlayer({ source, startTime, endTime, className }) {
  const playerRef = useRef(null);
  const handleProgress = (state) => {
    const currentTime = state.playedSeconds;
    if (currentTime >= endTime && playerRef.current) {
      playerRef.current.seekTo(startTime); 
    }
  }

  return (
    <>
      <div
        className={`${className} video-loop w-full h-full`}
      >
        <ReactPlayer
            ref={playerRef}
            url={source}
            loop
            controls={false}
            playing={true}
            playsinline={true}
            muted={true}
            light={false}
            onProgress={handleProgress}
            width={"100%"}
            height={"100%"}
            style={{ position: 'relative', zIndex: 1 }}
          />
      </div>
    </>
  );
};

export default LoopVideoPlayer;
